module.exports = __webpack_public_path__ + "static/media/S (132).21d74de3.jpg";